import React, { useEffect, useRef, useMemo, useState } from 'react';
import * as d3 from 'd3';
import { useDimensions } from './useDimensions';
import useIsMobile from './useIsMobile';

const AttacksOverTime = ({ data }) => {

    const containerRef = useRef(null);
    const dimensions = useDimensions(containerRef);
    const isMobile = useIsMobile();

    const svgRef = useRef(null);

    const processedData = useMemo(() => {
        const yearCount = d3.rollup(data, v => v.length, d => new Date(d.date).getFullYear());
        return Array.from(yearCount, ([year, count]) => ({
                year,
                count
              })).sort((a, b) => a.year - b.year);
    }, [data]);

    useEffect(() => {

        const margin = { top: 35, right: 12, bottom: 50, left: 25 };
        const { width, height } = dimensions;

        // const yearCount = d3.rollup (
        //     data,
        //     v => v.length,
        //     d => new Date(d.date).getFullYear()
        // );

        // const processedData = Array.from(yearCount, ([year, count]) => ({
        //     year,
        //     count
        //   })).sort((a, b) => a.year - b.year);

        

        const svg = d3.select(svgRef.current)
            .attr('width', width)
            .attr('height', height + margin.bottom + margin.top);

        d3.select(svgRef.current).selectAll('*').remove();

        // Scales
        const xScale = d3.scaleLinear()
            .domain([2000, 2025])
            .range([margin.left, width - margin.right]);

        const yScale = d3.scaleLinear()
            .domain([0, d3.max(processedData, (d) => d.count) * 1.1])
            .nice()
            .range([height - margin.bottom, margin.top]);

        // Line Generator
        const line = d3.line()
            .x((d) => xScale(d.year))
            .y((d) => yScale(d.count));

        svg.append("g")
          .attr("class", "svg-grid")
          .attr("transform", `translate(${margin.left}, 0)`)
          .call(
            d3.axisLeft(yScale)
            .tickSize(-width + margin.left + margin.right)
            .tickFormat("")
          )
          .select(".domain")
          .attr("stroke", "none");

        // Draw Axes
        const xAxis = d3.axisBottom(xScale)
            .tickFormat(d3.format("d"))
            .tickPadding(6)
            .ticks (width / 100);

        const yAxis = d3.axisLeft(yScale)
            .tickSize(0)
            .tickPadding(10)
            .tickFormat((d) => d !== 0 ? d : "");

        svg.append("g")
            .attr("class", "x-axis")
            .attr("transform", `translate(0,${height - margin.bottom})`)
            .call(xAxis);

        svg.append("g")
            .attr("class", "y-axis")
            .attr("transform", `translate(${margin.left},0)`)
            .call(yAxis)
            .select(".domain")
            .attr("opacity", 0);

        // Draw Line
        svg.append("path")
            .datum(processedData)
            .attr("fill", "none")
            .attr("stroke", "var(--china)")
            .attr("stroke-width", isMobile ? 1.5 : 2)
            .attr("d", line);

        const Tooltip = d3.select("body")
          .append("div")
          .attr("class", "tooltip")
          .style("opacity", 0);

        const handleMouseOver = (event, d) => {
            Tooltip.style("opacity", 1);
            d3.select(event.currentTarget)
                .transition()
                .duration(200)
                .attr("r", isMobile ? 4 : 5)
                .attr("stroke", "#fff");
        };

        const handleMouseMove = (event, d) => {

            Tooltip
                .html(`
                    <span class="tooltip__num"><b>${d.year}</b></span>年发生了<span class="tooltip__num"><b>${d.count}</b></span>起无差别袭击事件
                    `)
                .style("left", (event.pageX + 10) + "px")
                .style("top", (event.pageY - 10) + "px");
        };

        const handleMouseOut = (event) => {
            Tooltip.style("opacity", 0);
            d3.select(event.currentTarget)
                .attr("r", isMobile ? 3 : 4)
                .attr("stroke", "var(--china)");

        };

        svg.selectAll("circle")
            .data(processedData)
            .enter()
            .append("circle")
            .attr("cx", (d) => xScale(d.year))
            .attr("cy", (d) => yScale(d.count))
            .attr("r", isMobile ? 3 : 4)
            .attr("fill", "var(--china)")
            .attr("stroke", "var(--china)")
            .on("mouseover", handleMouseOver)
            .on("mousemove", handleMouseMove)
            .on("mouseout", handleMouseOut);


        // Add labels
        svg.append('text')
            .attr("class","axes")
            .attr("x", 2)
            .attr("y", 13)
            .text("袭击事件频率");

        svg.append('text')
            .attr("class","axes")
            .attr("y", height - margin.bottom / 3 + 20 )
            .attr("x", width / 2)
            .style('text-anchor', 'middle')
            .text('年份');

        const callouts = [
            { year: 2020, note: "新冠病毒在武汉爆发", yOffset: 0, lines: 2 },
            { year: 2022, note: "中国实施了旅行禁令和清零政策", yOffset: 45, lines: 3 }
        ];

        callouts.forEach(({ year, note, yOffset, lines }) => {
            const callout = processedData.find((d) => d.year === year);

            if (callout) {

                // const longNote = note.split(/\n/);
                // const extraSpace = (longNote.length - 1) * 18;

                svg.append("line")
                    .attr("x1", xScale(callout.year))
                    .attr("y1", yOffset + (22 * lines) )
                    .attr("x2", xScale(callout.year))
                    .attr("y2", yScale(callout.count) - 25)
                    .attr("stroke", "white")
                    .attr("stroke-width", 0.5)
                    .attr("opacity", 0.8);

                // const text = svg.append("text")
                //     .attr("class", "callout")
                //     .attr("x", xScale(callout.year))
                //     .attr("y", (yOffset + margin.top))
                //     .attr("text-anchor", "middle");
                //     // .text(note);

                svg.append("foreignObject")
                    .attr("class", "callout")
                    .attr("x", xScale(callout.year) - 35)
                    .attr("y", yOffset)
                    .attr("width", 70)
                    .attr("height", 60)
                    .append("xhtml:div")
                    .html(note);
                
                // longNote.forEach((note, i) => {
                //     text.append("tspan")
                //         .attr("x", xScale(callout.year))
                //         .attr("dy", i === 0 ? 0 : 19)
                //         .text(note);
                // });

                
            }
        }
    );



    }, [processedData, dimensions]);

    

    return (
    <>
    <div className='center-container'>
        <div className='article-body'>
            <h2>中国无差别袭击事件呈上升趋势</h2>
            <p className='subheader'>2018年和2024年是高峰</p>
        </div>
        <div className='spacerdiv' />

        <div ref={containerRef} className='container-ref' style={{  height:"500px" }}>
        {/* <h4>无差别袭击呈上升趋势</h4> */}
        <svg ref={svgRef}></svg>
        </div>

        <div className='article-body'>     
            <p>歪脑研究发现，中国的无差别袭击事件，逐年呈上升趋势。公开资料表明，自2018年起，平均每年发生10起案件。此前，每年只有4.2起案件。在2018年和2024年都出现明显高峰, 2024年达到顶峰。</p>
            

        </div>
        
        
    </div>
    </>
    );
};

export default AttacksOverTime;